<template>
  <v-container>
    <v-layout row wrap v-if="!loaded">
      <v-flex offset-xs5 offset-sm6 pt-5>
        <v-progress-circular :size="70" :width="7" color="light-blue darken-4" indeterminate></v-progress-circular>
      </v-flex>
    </v-layout>
    <v-card v-if="loaded">
      <v-card-title class="headline">Utenti</v-card-title>
      <v-layout row wrap mb-3>
        <v-flex xs4 md2 ml-3>
          <v-select v-model="filter" :items="parameters" label="Filtro Utenti"></v-select>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex xs12 md8 lg5 mx-3>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Cerca"
            single-line
            hide-details
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="headers"
        :items="filteredUsers"
        :search="search"
        :loading="loading"
        :rows-per-page-items="[10,25,40]"
        rows-per-page-text="Righe per pagina"
      >
        <template v-slot:items="props">
          <tr :class="props.item.color">
            <td>
              <v-icon
                color="green accent-4"
                @click="changeStatus(props.item.id, props.item.autorizzato)"
                v-if="props.item.autorizzato == '1'"
              >how_to_reg</v-icon>
              <v-icon
                color="yellow accent-4"
                @click="changeStatus(props.item.id, props.item.autorizzato)"
                v-if="props.item.autorizzato == '0' && props.item.verificato == '1'"
              >block</v-icon>
              <v-icon color="red accent-4" v-if="props.item.verificato == '0'">report</v-icon>
            </td>
            <td>{{ props.item.cognome }}</td>
            <td>{{ props.item.nome }}</td>
            <td>{{ props.item.email }}</td>
            <td class="centerDetailsIcon">
              <v-icon color="black" @click="selectUser(props.item.id)">visibility</v-icon>
            </td>
            <td class="centerDeleteIcon">
              <v-icon
                color="black"
                @click="deleteUser(props.item.id)"
                v-if="props.item.obsoleto === '0'"
              >person_add_disabled</v-icon>
              <v-icon
                color="black"
                @click="restoreUser(props.item.id)"
                v-if="props.item.obsoleto === '1'"
              >person_add</v-icon>
            </td>
          </tr>
        </template>
        <template v-slot:no-results>
          <v-alert
            :value="true"
            color="error"
            icon="warning"
          >La tua ricerca per "{{ search }}" non ha dato risultati.</v-alert>
        </template>
        <template v-slot:no-data>
          <v-alert :value="true" color="error" icon="warning">Nessun valore da visualizzare</v-alert>
        </template>
        <template
          v-slot:pageText="props"
        >{{ props.pageStart }} - {{ props.pageStop }} di {{ props.itemsLength }}</template>
      </v-data-table>
    </v-card>
    <v-flex mt-5 v-if="loaded">
      <v-card max-width="300">
      <v-list>
        <v-list-tile v-for="item in items" :key="item.text">
          <v-list-tile-action>
            <v-icon v-text="item.icon"></v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title v-text="item.text"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-card>
    </v-flex>
    
  </v-container>
</template>

<script>
import * as firebase from "firebase";
import { db } from "../main";
import { bus } from "../main";
export default {
  data: () => ({
    search: "",
    color: "red",
    items: [
      { text: "autorizzato", icon: "how_to_reg" },
      { text: "non autorizzato", icon: "block" },
      { text: "non verificato", icon: "report" },
      { text: "disabilita utente", icon: "person_add_disabled" },
      { text: "riattiva utente", icon: "person_add" }
    ],
    headers: [
      {
        text: "Autorizzato",
        align: "left",
        sortable: false,
        value: "autorizzato"
      },
      {
        text: "Cognome",
        value: "cognome"
      },
      {
        text: "Nome",
        value: "nome"
      },
      {
        text: "Email",
        value: "email"
      },
      {
        text: "Visualizza",
        value: ""
      },
      {
        text: "Attiva/Disattiva",
        value: ""
      }
    ],
    users: [],
    filteredUsers: [],
    parameters: ["Tutti", "Disattivi", "Attivi"],
    filter: "Attivi",
    loaded: false,
    loading: false,
    courses: []
  }),
  watch: {
    //filtro per la tabella degli utenti
    filter(filter) {
      const users = this.users;
      this.filteredUsers = [];
      users.forEach(user => {
        if (filter === "Tutti") {
          this.filteredUsers.push(user);
        } else if (filter === "Attivi") {
          if (user.obsoleto === "0") {
            this.filteredUsers.push(user);
          }
        } else if (filter === "Disattivi") {
          if (user.obsoleto === "1") {
            this.filteredUsers.push(user);
          }
        }
      });
    }
  },
  methods: {
    //metodo per il riempimento della tabella Utenti
    listener() {
      db.collection("utenti").onSnapshot(
        querySnapshot => {
          this.users = [];
          this.filteredUsers = [];
          var autorizzato = false;
          var color = "";
          var obsoleto = "";
          querySnapshot.forEach(doc => {
            autorizzato = false;
            color = "";
            obsoleto = "";
            if (doc.data().obsoleto === "1") {
              color = "greyColor";
              obsoleto = "1";
            } else {
              color = "";
              obsoleto = "0";
            }
            if (doc.data().autorizzato === "1") {
              autorizzato = true;
            }
            const user = {
              email: doc.data().email,
              nome: doc.data().nome,
              cognome: doc.data().cognome,
              autorizzato: autorizzato,
              verificato: doc.data().verificato,
              id: doc.id,
              color: color,
              obsoleto: obsoleto
            };
            this.users.push(user);
            if (user.obsoleto === "0") {
              this.filteredUsers.push(user);
            }
          });
          this.loaded = true;
        },
        function(error) {
          bus.$emit(
            "errorOperation",
            "Errore: problema nel caricamento degli utenti(" + error + ")"
          );
        }
      );
    },

    //metodo per autorizzare o no un utente alla navigazione del sito
    changeStatus(id, authorized) {
      let temp = "";
      if (authorized == "1") {
        temp = "0";
      } else {
        temp = "1";
      }
      db.collection("utenti")
        .doc(id)
        .update({
          autorizzato: temp
        })
        .catch(error => {
          bus.$emit(
            "errorOperation",
            "Errore: problema nel cambio di autorizzazione dell'utente(" +
              error +
              ")"
          );
        });
    },

    //metodo per disattivare un utente ed eliminarlo dalle iscrizioni ai corsi
    deleteUser(id) {
      var courseID = "";
      if (confirm("Eliminare Utente?")) {
        const currentDay = new Date().toISOString().substr(0, 10);
        db.collection("utenti")
          .doc(id)
          .update({
            obsoleto: "1",
            data_obsolescenza: currentDay,
            autorizzato: "0"
          })
          .then(() => {
            db.collection("iscritti")
              .where("id_utente", "==", id)
              .get()
              .then(list => {
                list.forEach(element => {
                  if (element.data().id_utente === id) {
                    courseID = element.data().id_corso;
                    this.courses.push(courseID);
                    db.collection("iscritti")
                      .doc(element.id)
                      .delete()
                      .catch(error => {
                        bus.$emit(
                          "errorOperation",
                          "Errore: problema nella cancellazione dell'utente(" +
                            error +
                            ")"
                        );
                      });
                  }
                });
                this.courses.forEach(course => {
                  db.collection("corsi")
                    .doc(course)
                    .update({
                      posti_occupati: firebase.firestore.FieldValue.increment(
                        -1
                      )
                    })
                    .catch(error => {
                      bus.$emit(
                        "errorOperation",
                        "Errore: problema nella cancellazione dell'utente(" +
                          error +
                          ")"
                      );
                    });
                });
                this.filter = "Attivi";
                bus.$emit(
                  "successfullOperation",
                  "Utente eliminato con successo"
                );
              })
              .catch(error => {
                bus.$emit(
                  "errorOperation",
                  "Errore: problema nella cancellazione dell'utente(" +
                    error +
                    ")"
                );
              });
          })
          .catch(error => {
            bus.$emit(
              "errorOperation",
              "Errore: problema nella cancellazione dell'utente(" + error + ")"
            );
          });
      }
    },

    //metodo per ripristinare l'utente
    restoreUser(id) {
      if (confirm("Ripristinare Utente?")) {
        db.collection("utenti")
          .doc(id)
          .update({
            obsoleto: "0",
            data_obsolescenza: "0"
          })
          .then(() => {
            this.filter = "Attivi";
            bus.$emit(
              "successfullOperation",
              "Utente ripristinato con successo"
            );
          })
          .catch(error => {
            bus.$emit(
              "errorOperation",
              "Errore: problema durante il ripristino dell'utente(" +
                error +
                ")"
            );
          });
      }
    },
    //metodo per la selezione dell'utente
    selectUser(id) {
      this.$store.dispatch("setSelectedUser", id);
      this.$router.push("/users/" + id);
    }
  },

  //metodo per l'invocazione del metodo per la popolazione della tabella Utenti
  created() {
    this.listener();
  }
};
</script>
<style>
</style>
